import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const resultFunction = (walletAccounts, get) => walletAccounts.map(get);
export default defineSelectorResultFunction({
    id: 'all',
    resultFunction,
    dependencies: [
        { selector: 'names' },
        { selector: 'get' },
    ],
});
